import { orchestrator } from 'satcheljs';
import onRemoveProjection from 'owa-popout-v2/lib/actions/onRemoveProjection';
import cleanupWindowPaneState from '../mutators/cleanupWindowPaneState';
import cleanupWindowAnchorState from '../mutators/cleanupWindowAnchorState';

orchestrator(onRemoveProjection, async actionMessage => {
    const { tabId } = actionMessage;

    // Clean up all pane state entries for the destroyed window
    cleanupWindowPaneState(tabId);
    // Clean up any external mount anchor registered for the destroyed window
    cleanupWindowAnchorState(tabId);
});
